import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";

const NotFound = () => {

  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  return (
    <main id="main" class="main">

      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button className={`accordion-button ${accordTheme}`} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Not Found
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body"></div>
              <h2 style={{"margin-left":"10px"}}>404 - Not Found</h2>
              <p style={{"margin-left":"10px"}}>Sorry, the page you are looking for does not exist.</p>
          </div>
        </div>
      </div>

    </main>
  );
};

export default NotFound;